import { generateUniqueId } from '../../helpers/common';

export const SET_STATION_TIME_OFFSET = generateUniqueId();
export const SELECT_STATISTICS_STATION = generateUniqueId();
export const RESET_STATISTICS_STATION = generateUniqueId();
export const SET_SELECT_YEAR = generateUniqueId();

export const GET_ENERGY_METER_LIST = generateUniqueId();
export const GET_STATISTICS_TOTALIZE = generateUniqueId();

export const GET_STATISTICS_TYPE = generateUniqueId();
export const GET_STATISTICS_FACILITYS = generateUniqueId();
export const GET_OTHER_DATA = generateUniqueId();

export const GET_BI_DIRECTIONAL_METER = generateUniqueId();
export const GET_BI_DIRECTIONAL_FACILITIES = generateUniqueId();

export const SELECT_BI_DIRECTIONAL_STATION = generateUniqueId();
export const RESET_BI_DIRECTIONAL_STATION = generateUniqueId();

export const GET_BI_DIRECTIONAL_ENERGY_DATA = generateUniqueId();
export const GET_BI_DIRECTIONAL_ENERGY_FACILITY = generateUniqueId();
export const GET_BI_DIRECTIONAL_ENERGY_TYPE = generateUniqueId();

export const SELECT_VIEW_PERIOD = generateUniqueId();
export const SET_SELECTED_DAY = generateUniqueId();
export const SET_SELECTED_MONTH = generateUniqueId();
export const SET_SELECTED_YEAR = generateUniqueId();

export const RESET_BI_DIRECTIONAL_DATA = generateUniqueId();
export const GET_BI_DIRECTIONAL_DATA_DATES_REQUEST = generateUniqueId();
export const GET_BI_DIRECTIONAL_DATA_DATES_SUCCESS = generateUniqueId();
export const GET_BI_DIRECTIONAL_DATA_DATES_FAILURE = generateUniqueId();
export const UPDATE_BI_DIRECTIONAL_ENERGY_FILTER = generateUniqueId();
export const UPDATE_BI_DIRECTIONAL_METER_LIST = generateUniqueId();

export const RESET_STATISTICS_VIEW = generateUniqueId();
export const RESET_STATISTICS_DATE_SELECTIONS = generateUniqueId();
export const UPDATE_BI_DIRECTIONAL_DATES = generateUniqueId();

export const GET_PORTFOLIO_STATIONS = generateUniqueId();
export const GET_PORTFOLIO_STATIONS_SUCCESS = generateUniqueId();
export const GET_PORTFOLIO_STATIONS_FAILURE = generateUniqueId();

export const GET_PORTFOLIO_DETAILS_REQUEST = generateUniqueId();
export const GET_PORTFOLIO_DETAILS_SUCCESS = generateUniqueId();
export const GET_PORTFOLIO_DETAILS_FAILURE = generateUniqueId();

export const RESET_PORTFOLIO_DETAILS_FILTER = generateUniqueId();
export const UPDATE_PORTFOLIO_DETAILS_FILTER = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_COMPANY = generateUniqueId();
export const RESET_PORTFOLIO_COMPANY = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_CITY = generateUniqueId();
export const RESET_PORTFOLIO_CITY = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_COUNTRY = generateUniqueId();
export const RESET_PORTFOLIO_COUNTRY = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_PROJECT = generateUniqueId();
export const RESET_PORTFOLIO_PROJECT = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_YEAR = generateUniqueId();
export const RESET_PORTFOLIO_YEAR = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_STATIONS = generateUniqueId();
export const UPDATE_SELECTED_PORTFOLIO_STATIONS = generateUniqueId();
export const RESET_SELECTED_PORTFOLIO_STATIONS = generateUniqueId();

export const GET_PORTFOLIO_DATA = generateUniqueId();
export const RESET_PORTFOLIO_DATA  = generateUniqueId();
export const GET_PORTFOLIO_DATA_FAILURE = generateUniqueId();

export const GET_PORTFOLIO_TOTALIZE_DATA = generateUniqueId();
export const GET_PORTFOLIO_TOTALIZE_RESET  = generateUniqueId();
export const GET_PORTFOLIO_TOTALIZE_SUCCESS = generateUniqueId();
export const GET_PORTFOLIO_TOTALIZE_FAILURE = generateUniqueId();

export const FETCH_PORTFOLIO_LEVELS_REQUEST = generateUniqueId();
export const FETCH_PORTFOLIO_LEVELS_SUCCESS = generateUniqueId();
export const FETCH_PORTFOLIO_LEVELS_FAILURE = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_LEVEL = generateUniqueId();
export const RESET_SELECTED_PORTFOLIO_LEVEL = generateUniqueId();

export const GET_PORTFOLIO_STATISTICS_DATA = generateUniqueId();
export const RESET_PORTFOLIO_STATISTICS_DATA  = generateUniqueId();
export const GET_PORTFOLIO_STATISTICS_DATA_FAILURE = generateUniqueId();

export const RESET_BI_DIRECTIONAL_METER_LIST = generateUniqueId();

export const SET_PORTFOLIO_INFO_COMPANY = generateUniqueId();
export const GET_PORTFOLIO_INFO = generateUniqueId();
export const GET_PORTFOLIO_INFO_RESET  = generateUniqueId();
export const GET_PORTFOLIO_INFO_SUCCESS = generateUniqueId();
export const GET_PORTFOLIO_INFO_FAILURE = generateUniqueId();

export const SET_STATISTICS_CHART_VIEW = generateUniqueId();
export const SET_HEATMAP_MONTH = generateUniqueId();